import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from './auth.service';
import { UserRole } from './user-role.type';

export const roleGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const role = authService.getCurrentRole() as UserRole | null;
  const allowedRoles = (route.data?.['roles'] as UserRole[] | undefined) ?? [];

  if (!role || allowedRoles.length === 0 || allowedRoles.includes(role)) {
    return true;
  }

  const preferredSlug = authService.getPreferredCompanySlug();

  if (role !== 'system_admin' && preferredSlug) {
    return router.createUrlTree(['/', preferredSlug, 'appointments']);
  }

  return router.createUrlTree(['/appointments']);
};
